export function toFilter(filter: Object): string {
    const filters = [];
    for (const [key, value] of Object.entries(filter)) {
        if (value === undefined || value === null) {
            continue;
        }

        filters.push(`${key}:${value}`);
    }

    return filters.join(" AND ");
}

export function quote(value?: null | string): string | undefined {
    return value ? `"${value}"` : undefined;
}

export function quoteIfSpecialCharacters(value?: null | string): null | string | undefined {
    if (!value) {
        return value;
    }

    const trimmed = value.trim();
    if (!trimmed) {
        return trimmed;
    }

    if (trimmed.length > 1 && trimmed.startsWith('"') && trimmed.endsWith('"')) {
        return trimmed;
    }

    // Check for lucene special characters or whitespace
    const regex = /[+\-&|!(){}[\]^"~*?:\\/\s]/;
    if (trimmed && regex.test(trimmed)) {
        return quote(trimmed);
    }

    return trimmed;
}
